export class AgrupamentoStringboxCD {
  idAgrupamento: number;
  idCD: number;
  descricaoCD: string;
}
